import Trash from "@/pages/Trash";
import ResetData from "@/pages/ResetData";

export default function TrashReset({ me }) {
  return (
    <div className="space-y-10">
      <Trash me={me} />
      <div className="border-t border-ink/15 pt-8">
        <ResetData me={me} />
      </div>
    </div>
  );
}
